import React from 'react'

const DeliveryNote = () => <div>{/*<img alt="cataloge" src={`${require('../../assets/ZadigCatalogue.jpg')}`} />*/}</div>

export default DeliveryNote
